import React, { Component } from "react";
import { Grid, Avatar, Typography, Button } from '@material-ui/core';
import { connect } from "react-redux";
import StarIcon from '@material-ui/icons/Star';
import { webFont, textBlack, textGrey, primaryColor } from '../../config/theme';
const defaultChefImg = "/images/simple-chef.webp";
const tick = "/images/tick.webp";

class CList extends Component {
  state = {
    chefs: []
  };

  showChefProfile = chefId => {
    this.props.history.push("/home/chef-profile", { chefId, screen: 'chef-search' });
  };

  render() {
    const { chefs ,loading} = this.props;
    let fChefs = null;
    if (chefs.length > 0) {

      fChefs = chefs.map(chef => {
        let chefRatings = 0;
        let ratingStars = null;

        if (chef.rating) {
          if (chef.rating > 0) {
            chefRatings = Math.floor(chef.rating);
          }
        }

        if (chefRatings > 0) {
          switch (chefRatings) {
            case 1:
              ratingStars = <StarIcon style={style.ratingIcon} />;
              break;

            case 2:
              ratingStars = (
                <div>
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                </div>
              );
              break;

            case 3:
              ratingStars = (
                <div>
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                </div>
              );
              break;

            case 4:
              ratingStars = (
                <div>
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                </div>
              );
              break;

            case 5:
              ratingStars = (
                <div>
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                  <StarIcon style={style.ratingIcon} />
                </div>
              );
              break;
          }
        } else {
          chefRatings = "";
        }
        return (
          <Grid
            data-test-id={"cheffilterlist"}
            item
            xs={12}
            md={4}
            lg={3}
            sm={6}
            key={chef.id}
            style={style.featuredItem}
            onClick={() => this.showChefProfile(chef.id)}
          >
            <Grid container alignItems="center" justify="center" style={{ position: 'relative' }}>
              <Avatar
                src={chef.profilePic ? chef.profilePic : defaultChefImg}
                alt="Image not available"
                style={style.avatarImg}
              />
              {chef.verified && <div style={{ position: 'absolute', top: 0, right: 10 }}>
                <img src={tick} alt="Verified Chef" style={style.tick} />
              </div>}
              <Grid data-test-id={"acheffilterlist"} item xs={12}>
                <Typography
                  align="center"
                  variant="h6"
                  style={style.chefName}
                  gutterBottom={true}
                >
                  {chef.firstName} {chef.lastName}
                </Typography>
              </Grid>
              <Grid data-test-id={"bcheffilterlist"} item xs={12}>
                <Typography
                  align="center"
                  variant="body1"
                  style={style.chefCuisine}
                  gutterBottom={true}
                  noWrap={true}
                >
                  {chef.cuisines && chef.cuisines.length>2 ? "Multi Cuisines" :chef.cuisines.toString().replace(/,/g, ', ')}
                </Typography>
              </Grid>
              <Grid item xs={12} alignItems={"center"} alignContent={"center"} justify={"center"}>
                <Typography
                  align="center"
                  variant="body1"
                  style={style.chefCuisine}
                  gutterBottom={true}
                  noWrap={true}
                >
                  {chefRatings === '' ? chefRatings : ratingStars}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        );
      });
    }

    return (
      <Grid container direction="row" style={style.ftGrid} className="custom-columns">
        <Grid container alignItems="flex-start">
          {/* <Typography variant="h5" style={{fontWeight: 500, fontSize: 32, fontFamily: webFont, marginBottom: 40}}>
            Chefs
          </Typography> */}
        </Grid>
        {(fChefs === null && !loading) ?
            <Typography variant="h5" style={style.ftText}>
              No chefs found.
        </Typography>
            : fChefs}
        {!this.props.searching && (
          <Grid container alignItems="center" justify="center">
            <Button
            data-test-id={"chef-showall"}

              variant="contained"
              color="primary"
              style={style.showBtn}
              onClick={() => this.props.history.push("/home/chef-search")}
            >
              Show All
            </Button>
          </Grid>
        )}
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
  };
};

const ChefList = connect(mapStateToProps)(CList);

export default ChefList;

const style = {
  avatarImg: {
    width: 203,
    height: 203,
    border: '1px solid #ff8000'
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    marginBottom: 30,
    marginTop: 30,
    width: '100%',
    textAlign: 'center'
  },
  chefName: {
    fontFamily: webFont,
    color: '#444444',
    fontWeight: 500,
    marginTop: 12,
    marginBottom: 1,
    fontSize: 20,
  },
  chefCuisine: {
    fontFamily: webFont,
    weight: 500,
    maxWidth: '100%',
    color: '#979797',
    opacity: '0.8',
    margin: 0,
    fontSize: 15
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  ratings: {
    color: primaryColor,
    weight: 500,
    maxWidth: '100%'
  },
  ratingIcon: {
    color: primaryColor
  },
  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    color: '#fff'
  },
  tick: {
    width: 28,
    height: 28,
  }
};
